<template>
    <multiselect class="custom-dropdown" :class="{ dark }" :show-labels="false" tag-placeholder="+" v-bind="{ ...$props, ...$attrs }" v-on="$listeners">
        <template #noOptions>Aucun élément trouvé</template>
    </multiselect>
</template>

<script>
    import multiselect from "vue-multiselect";

    export default {
        props: {
            dark: {
                type: Boolean
            },
            placeholder: {
                type: String,
                default: ""
            },
            label: {
                type: String,
                default: "nom"
            },
            trackBy: {
                type: String,
                default: "id"
            },
            options: {
                type: Array,
                default: () => []
            }
        },
        components: {
            multiselect
        }
    };
</script>

<style lang="scss">
    .multiselect {
        min-height: 0 !important;
    }
    .multiselect.custom-dropdown {
        .multiselect__select {
            z-index: 2;
        }

        .multiselect__single {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding-right: 30px;
        }

        &.dark {
            .multiselect__tags {
                background-color: darken($primary, 10%) !important;
                border: none !important;
                border-radius: 30px;
                padding-left: 20px !important;
            }

            .multiselect__placeholder {
                font-size: 0.8125rem;
                color: #fff !important;
                opacity: 0.5;
            }

            .multiselect__input {
                background: none !important;
                padding-left: 0;
                color: #fff !important;

                &::placeholder {
                    color: rgba(#fff, 0.5);
                }
            }

            .multiselect__single {
                background: none !important;
                color: #fff;
            }

            .multiselect__select {
                border-radius: 50%;

                &::before {
                    color: #fff;
                    border-color: #fff transparent transparent;
                }
            }
        }
    }
</style>
